import { NodeViewWrapper, NodeViewWrapperProps } from '@tiptap/react';
import { FC, useCallback, useEffect, useRef } from 'react';
import cn from 'classnames';
import { DaDeviationAttrs } from '../deviation';
import { getPresetId } from '../../../components/utils/tiptap';
import DaDeviation from './DaDeviation';
import { EXTENSION_TYPE_NAME } from '../constants';

import viewerStyles from '../Viewer/Viewer.scss';

const DeviationNodeView: FC<NodeViewWrapperProps> = props => {
  const Renderer = props.editor.extensionStorage['da-ext-renderers'].deviation;
  const { editor, updateAttributes, extension, node } = props;
  const { options } = extension;
  const attrs: DaDeviationAttrs = node.attrs;
  const editorDomRef = useRef<HTMLElement>(undefined);

  useEffect(() => {
    editorDomRef.current = editor.view.dom;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onResizeEnd = useCallback(
    (nextWidth: number) => {
      updateAttributes({
        width: nextWidth,
      });
    },
    [updateAttributes]
  );

  const nodeKey = `img-${!attrs.width ? 'default' : 'custom'}`;

  return (
    <NodeViewWrapper
      key={nodeKey}
      data-drag-handle="true"
      data-da-type={EXTENSION_TYPE_NAME}
      className={cn(
        'draggable-atomic',
        viewerStyles['deviation-container'],
        viewerStyles[attrs.alignment],
        options.smallMedia && viewerStyles['small-media'],
        viewerStyles[`preset-${getPresetId(editor)}`]
      )}
    >
      <DaDeviation
        deviation={attrs.deviation}
        link={attrs.link ?? undefined}
        Renderer={Renderer}
        onResizeEnd={onResizeEnd}
        extOptions={options}
        alignment={attrs.alignment}
        attrWidth={attrs.width}
        defaultWidth={options.defaultWidth}
        editorDomRef={editorDomRef}
      />
    </NodeViewWrapper>
  );
};
DeviationNodeView.displayName = 'DeviationNodeView';

export default DeviationNodeView;
